export default __webpack_public_path__ + "static/media/DSS_HeroBanner_675x300_PowerTools_Final.52c60d37.gif";